import { defineRecipe } from '@chakra-ui/react';

export const badgeRecipe = defineRecipe({
	className: 'chakra-badge',

	base: {
		alignItems:         'center',
		borderRadius:       'full',
		colorPalette:       'primary',
		display:            'inline-flex',
		fontVariantNumeric: 'tabular-nums',
		fontWeight:         'bold',
		gap:                '1',
		py:                 '1',
		userSelect:         'none',
		whiteSpace:         'nowrap',
	},
	defaultVariants: {
		size:    'sm',
		variant: 'solid',
	},
	variants: {
		size: {
			lg: {
				minH:      '7',
				px:        '4.5',
				textStyle: 'sm',
			},
			md: {
				minH:      '6',
				px:        '4',
				textStyle: 'sm',
			},
			sm: {
				minH:      '5',
				px:        '3.5',
				textStyle: 'xs',
			},
			xs: {
				minH:      '4',
				px:        '3',
				textStyle: '2xs',
			},
		},
		variant: {
			outline: {
				color:       'colorPalette.solid',
				shadow:      'inset 0 0 0px 1.5px var(--shadow-color)',
				shadowColor: 'colorPalette.solid',
			},
			solid: {
				bg:    'colorPalette.solid',
				color: 'colorPalette.contrast',
			},
		},
	},
});
